var React = require('react');

function GiftCardLightInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"opacity":"0.7","cx":"12.5","cy":"12.5","r":"12.5","fill":"#EFF1FF","key":0}),React.createElement("path",{"d":"M16.3086 10.1196H14.6899V9.9292C14.6899 8.71997 13.7092 7.73926 12.5 7.73926C11.2908 7.73926 10.3101 8.71997 10.3101 9.9292V10.1196H8.69141C8.48074 10.1196 8.31055 10.2898 8.31055 10.5005V16.8799C8.31055 17.0905 8.48074 17.2607 8.69141 17.2607H16.3086C16.5193 17.2607 16.6895 17.0905 16.6895 16.8799V10.5005C16.6895 10.2898 16.5193 10.1196 16.3086 10.1196ZM13.833 10.1196H11.167V9.9292C11.167 9.19247 11.7633 8.59619 12.5 8.59619C13.2367 8.59619 13.833 9.19247 13.833 9.9292V10.1196Z","fill":"#40196D","key":1})]);
}

GiftCardLightInline.defaultProps = {"width":"25","height":"25","viewBox":"0 0 25 25","fill":"none"};

module.exports = GiftCardLightInline;

GiftCardLightInline.default = GiftCardLightInline;
